

import React, { memo, useMemo } from 'react';

import AddonView from '../../AddonView/AddonView';







function AdditionalOutputAddonView({
  addon,
  addonType,
  getAdditionalOutputs
}) {
  const viewItem = useMemo(() => {
    const [additionalOutputs] = getAdditionalOutputs({ [addonType]: [addon] });

    const { captionValue: { prefix, label, value }, title } = additionalOutputs;

    if (!value) return null;

    return {
      iconName: prefix,
      text: title,
      subText: label,
      price: addon.cost
    };
  }, [addonType, addon]);

  return viewItem &&
  <AddonView
    {...viewItem} />;


}

export default memo(AdditionalOutputAddonView);